// 腾讯云视频上传
import Axios from '../ajax'
export default {
  methods: {
    /**
     * 计算签名
    **/
    async getSignature() {
      let {data} = await Axios.post('https://ueclub.kingdee.com/api/video/get_sign', {}, {
        withCredentials: false
      })
      return data.data.signature
    },
     /**
      * 获取播放参数信息
      **/
    async getPlayInfo(fileId) {
      let {data} = await Axios.post('https://ueclub.kingdee.com/api/video/get_play_info',{
            fileId: fileId,
          }, {
            withCredentials: false
          })
      return data
    },
    /**
     * 视频入库
     **/
    async getCreate(video) {
      await Axios.post('https://ueclub.kingdee.com/api/video/get_create', {
        fileId: video.fileId,
      }, {
        withCredentials: false
      })
      return
    },
    /*
     *防盗链地址获取
     */
    async getAntiLeechUrl(videoUrl) {
      let {data} = await Axios.post('https://demo.vod2.myqcloud.com/ugc-upload/', JSON.stringify({
        Action: "GetAntiLeechUrl",
        Url: videoUrl,
      }), {
        withCredentials: false
      })
      return data.data.url
    }
  }
}